<template>
  <div>
    <h2 class="tw-text-2xl">
      Estrogen Therapy
    </h2>
    <p :class="{'tw-text-lg': isOnboardingRedesign}">
      Primarily used for relieving menopause and perimenopause symptoms, estrogen replacement therapy can reduce hot flashes and night sweats; treat vulvar and vaginal atrophy (thinning and drying of the vaginal tissues); prevent and treat osteoporosis and osteopenia (weakening of the bones); and treat estrogen deficiency from menopause, surgical removal of the ovaries, or primary ovarian failure.
      <br>
      <br>
      The most common side effects from taking estrogen are headaches, breast tenderness, nausea, vaginal spotting, and bloating. For most women, these side effects resolve on their own after a few weeks. Serious side effects are rare; they include cancer of the uterus, breast, and ovaries, stroke, blood clots, and gallbladder disease.
      <br>
      <br>
      Women with a uterus should use progesterone in addition to estrogen in order to prevent overgrowth of cells in the uterine lining. Women who are pregnant; breast feeding; have cancer of the breast, uterus, ovaries, or cervix; have had a stroke or heart attack in the last year; have or have had blood clots; have active liver disease; or are allergic to estrogen should not take estrogen replacement therapy.
    </p>
    <h2 class="tw-text-2xl">
      Progesterone Therapy
    </h2>
    <p :class="{'tw-text-lg': isOnboardingRedesign}">
      Progesterone is primarily used in tandem with estrogen to prevent endometrial hyperplasia (overgrowth of the uterine lining) and uterine cancer for women who still have a uterus.
      <br>
      <br>
      The most common side effects from taking progesterone are headaches, breast tenderness, nausea, vaginal spotting, and bloating. For most women, these side effects resolve on their own after a few weeks. Serious side effects are rare; they include cancer of the uterus, breast, and ovaries, stroke, blood clots, and gallbladder disease.
      <br>
      <br>
      Women who are pregnant; breast feeding; have cancer of the breast, uterus, ovaries, or cervix; have had a stroke or heart attack in the last year; have or have had blood clots; have active liver disease; or are allergic to progesterone should not take progesterone replacement therapy. The progesterone capsules contain peanut oil and should not be used by women with peanut allergies.
    </p>
    <h2 class="tw-text-2xl">
      DHEA Supplementation
    </h2>
    <p :class="{'tw-text-lg': isOnboardingRedesign}">
      Dehydroepiandrosterone (DHEA) is naturally produced by the adrenal glands and serves as a precursor testosterone and estrogen. DHEA supplementation is often used to address hormonal imbalances, support adrenal function, improve bone density, and enhance mood and sexual function, particularly in individuals with low levels due to aging or certain medical conditions.
      <br>
      <br>
      The most common side effects of taking DHEA include acne, oily skin, hair thinning, and changes in mood or libido. These side effects are generally mild and may subside after a few weeks. Serious side effects are rare but can include hormonal imbalances, liver damage, and increased risk of certain hormone-sensitive cancers. These risks are often correlated to high doses of DHEA, which Winona does not prescribe.
      <br>
      <br>
      Individuals who are pregnant, breastfeeding, have hormone-sensitive conditions (such as breast or ovarian cancer), liver disease, or are allergic to DHEA should avoid taking DHEA supplements. It's also not recommended for those with a history of heart disease, high cholesterol, or uncontrolled blood pressure without consulting a doctor.
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
  }
}
</script>